import { Loader } from '@/components/atom/Loader';
import { Modal, ModalProps } from '@/components/molecule/Modal';
import WalletConnection from '@/components/wallet/WalletConnection';
import { useWhitelist } from '@/hooks/game/whitelist';
import { appConfigAtom } from '@/state/app';
import { walletAtom } from '@/state/wallet';
import NextImage from 'next/image';
import { useRouter } from 'next/router';
import { BsArrowLeft } from 'react-icons/bs';
import { useRecoilValue } from 'recoil';
import { Button } from '../atom/Button';
import { CountdownTimer } from '../atom/CountdownTimer';

// Component to display the time remaining until the whitelist is lifted
type WhitelistCountdownProps = Pick<ModalProps, 'onClose'> & {
    children: JSX.Element;
};

export const WhiteListDate = new Date('2023-03-07T06:00:00Z');

const WhitelistModal = ({ onClose, children }: WhitelistCountdownProps) => {
    useWhitelist();
    const appConfig = useRecoilValue(appConfigAtom);
    const walletState = useRecoilValue(walletAtom);
    const router = useRouter();
    const handleStakeClick = () => {
        router.push('/');
    };

    const handleGameClick = () => {
        router.push('/game');
    };

    const isExpired = WhiteListDate.getTime() < new Date().getTime();
    const title = isExpired ? 'Exchange is Here!' : 'Whitelist is Here!';
    const description = isExpired
        ? 'Collect all the four NFTs to get access to the whitelist.'
        : 'Get backdoor access to our Exchange by participating in the Game! Set your reminders for when the Game launches.';

    const WhitelistCountdownBody = () => {
        return (
            <div className="flex flex-col pt-8">
                <div className="flex">
                    <div className="flex flex-col w-3/5">
                        <div
                            className="flex items-center space-x-2 text-white cursor-pointer t__button--u2"
                            onClick={handleStakeClick}
                        >
                            <BsArrowLeft className="text-white" size={'12px'} />
                            <span>Back to staking</span>
                        </div>
                        <span className="text-white t__heading--h4 mt-7">{title}</span>
                        <span className="mt-6 t__body--b2 text-grey-20">{description}</span>
                        {isExpired ? (
                            <Button className="mt-6" size="block" variant="primary-white" onClick={handleGameClick}>
                                Play
                            </Button>
                        ) : (
                            <div className="flex flex-col items-start justify-center mt-6 t__subtitle--s2 text-grey-20">
                                <span className="mb-4">The game starts in</span>
                                <CountdownTimer endTime={WhiteListDate} variant="game" />
                            </div>
                        )}
                    </div>
                    <NextImage
                        className="z-0"
                        src={'/assets/game/whitelist_modal_bg.svg'}
                        height={isExpired ? '320px' : '389px'}
                        width="315px"
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            {!walletState.selectedAddress ? (
                <WalletConnection />
            ) : // TODO place loader in the screen middle
            appConfig.isWhitelisted == undefined ? (
                <Loader />
            ) : appConfig.isWhitelisted ? (
                children
            ) : (
                <Modal
                    isVisible={true}
                    isClosable={false}
                    onClose={onClose}
                    isArrowOutside={false}
                    modalWidth="w-[659px]"
                    titleAlign="left"
                    bodyPadding="pt-4 pl-4 md:pt-6 md:pl-6"
                    titlePadding="px-4 md:px-6 pt-6 pb-2"
                    className=" bg-gradient-to-br from-[#140F1B] to-[#30171C]"
                    body={<div>{WhitelistCountdownBody()}</div>}
                />
            )}
        </>
    );
};

export default WhitelistModal;
